export const breakpoints = {
  mobile: '812px',
  tablet: '1024px',
  laptop: '1366px',
  desktop: '1920px',
};
